module.exports = __webpack_public_path__ + "/img/SOIC-SOP-931VbA.svg";